<template>
    <van-tabbar  class="tabbar_top">

      <van-tabbar-item icon="apps-o" @click="Skip('takeOutHome')"
        >  {{ tools.GetLanguageValue("public.app.菜单") }}</van-tabbar-item
      >
       <van-tabbar-item icon="orders-o" @click="Skip('takeOutCollection')"
        >  {{ tools.GetLanguageValue("public.app.套餐") }}</van-tabbar-item
      >
      <van-tabbar-item
        v-if="!tableCart"
        icon="shopping-cart-o"
        @click="SkipUserIsAuthenticated('myShoppingCart')"
        >  {{ tools.GetLanguageValue("public.app.购物车") }}</van-tabbar-item
      >

      <van-tabbar-item v-if="!tableCart" icon="manager-o" @click="SkipUserIsAuthenticated('my')"
        >  {{ tools.GetLanguageValue("public.app.用户") }}</van-tabbar-item
      >
    </van-tabbar>
  </template>
<script >
import axios from "../../commons/AxiosMethod.js"
import tools from "../../commons/tools.js"
// product_categorys
export default {
  data () {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      UserIsAuthenticated: true,
      tableCart: false,
      tools: tools
    }
  },
  props: {
    active: ""

  },
  name: "App",
  mounted () {
    this.GetUserIsAuthenticated()
    this.IsTableCart()
  },
  components: {},
  methods: {
    IsTableCart () {
      this.tableCart = sessionStorage.getItem("tableCart") == "tableCart"
    },
    // 验证是否登录
    SkipUserIsAuthenticated (url) {
      if (this.UserIsAuthenticated) {
        this.Skip(url)
      } else {
        this.Skip("login")
      }
    },
    Skip (item) {
      this.$router.push({
        path: item
      })
    },
    // 验证是否登录
    GetUserIsAuthenticated () {
      var param = {}
      axios.apiMethod(
        "/api/User/GetUserIsAuthenticated",
        "get",
        param,
        (result) => {
          if (result.Code == 200) {
            if (result.Data.Type == 401) {
              this.UserIsAuthenticated = false
            }
          }
        }
      )
    }

  }
}
</script>
  <style lang="scss" scoped>
  .tabbar_top {
    border-top: 1px solid #eee;
  }
  </style>
